export default __webpack_public_path__ + "static/media/noData.2d4a7b28.svg";